import React, { useState } from 'react';
import CurrenciesAdminList from './components/CurrenciesAdminList';
import CurrenciesAdminAddCurrencyPage from './components/CurrenciesAdminAddCurrencyPage';

import { Box, Tabs, Tab } from '@mui/material';



const CurrenciesAdminPage: React.FC = () => {
  const [tab, setTab] = useState(0);

  const handleTabChange = (_: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs value={tab} onChange={handleTabChange} aria-label="AdSpaces admin tabs">
        <Tab label="List Currencies" />
        <Tab label="Insert Currency" />
      </Tabs>
      <Box sx={{ mt: 2 }}>
        {tab === 0 && <CurrenciesAdminList />}
        {tab === 1 && <CurrenciesAdminAddCurrencyPage />}
      </Box>
    </Box>
  );
};

export default CurrenciesAdminPage;